"use client";

import React, { useCallback, useEffect, useRef } from "react";
import styles from "./FeeSectionProgramTempleteLp.module.scss";
import popupData from "@/data/popup-data.json";
import { pushToDataLayer } from "@/helpers/gtag";
import { useModalDispatch } from "@/context/ModalContext";
import { IModalActions, ModalTypes } from "@/types/modal";
import { getGlobalStateValue, updateStateSession } from "@/context/utils";
import { warmLeadModals } from "@/helpers/leadModalGate";
import clsx from "clsx";
import { isUsCountry } from "@/helpers/countryCode";

interface FeesProps {
  associatedPrograms?: any;
  TileSection?:any
  country?: string;
  Brochure?: {
    data?: {
      attributes?: {
        url?: string;
      };
    };
  };
}
export default function FeeSectionProgramTempleteLp({associatedPrograms,Brochure = {},TileSection,country}: FeesProps)

{
  const BrochureLink=Brochure?.data?.attributes?.url
  const modalDispatch = useModalDispatch();
  const sectionRef = useRef<HTMLDivElement>(null);

  const warmModals = useCallback(() => {
    warmLeadModals();
  }, []);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el || typeof IntersectionObserver === "undefined") return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          warmModals();
          observer.disconnect();
        }
      },
      { rootMargin: "240px 0px" },
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [warmModals]);

  const openModal = (sectionName, modalVariant, eventName) => {
    warmModals();

     pushToDataLayer({
      event: "lead_initiate",
      cta_text: "Reserve Your Seat",
      section_name: "hero_card",
      page_type: getGlobalStateValue("pageType"),
      page_url: window.location.href,
    });

    updateStateSession({
      parentSection: "hero_card",
      leadStartingCta: "Reserve Your Seat",
    });

    
    // Open Modal
    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
        modalType: ModalTypes.ConnectModalMba,
        modalData: {
          associatedPrograms,
          isLandingPage: true,
          popup: popupData,
          modalVariant,
          isLambdaAPI: true,
          rfiCase: "THANK_YOU_PAGE_CASE"
        },
      },
    });
  };


  const downloadBrochureCase = (modalVariant) => {
    warmModals();
    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
        modalType: ModalTypes.ConnectModalMba,
        modalData: {
          associatedPrograms,
          rfiCase: "DOWNLOAD_BROCHURE_CASE_THANK_YOU",
          attachmentURL: BrochureLink,
          modalVariant,
          isLambdaAPI: true
        },
      },
    });


     pushToDataLayer({
      event: "lead_initiate",
      cta_text: "Download Now",
      section_name: "hero_card",
      page_type: getGlobalStateValue("pageType"),
      page_url: window.location.href,
    });

    updateStateSession({
      parentSection: "hero_card",
      leadStartingCta: "Download Now",
    });

  };

  const downloadEMICase = (Link) => {
    warmModals();
    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
        modalType: ModalTypes.ConnectModalMba,
        modalData: {
          associatedPrograms,
          rfiCase: "EMI_CASE_THANK_YOU",
          attachmentURL: Link?.data?.attributes?.url || "",
          modalVariant: "emiPlan",
          isLambdaAPI: true
        },
      },
    });

     pushToDataLayer({
      event: "lead_initiate",
      cta_text: "Check EMI",
      section_name: "hero_card",
      page_type: getGlobalStateValue("pageType"),
      page_url: window.location.href,
    });

    updateStateSession({
      parentSection: "hero_card",
      leadStartingCta: "Check EMI",
    });
  }

  const openSchorshipRFI = () => {
    warmModals();
    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
        modalType: ModalTypes.scholarshipRFI,
        modalData: {
          associatedPrograms,
          isLandingPage: true
        },
      },
    });

  };

 const invokeRFI = ({ ENUM, Link }) => {

  switch (ENUM) {
    case "DOWNLOAD_BROCHURE":
      downloadBrochureCase("downloadBrochure");
      
      break;

     case "SCHOLOSHIP_LINK":
        openSchorshipRFI();
     break;

     case "EMI_RFI":
        downloadEMICase(Link);
     break;

     case "RFI_FORM":
       openModal(
            "Admission Open",
            "seatReservation",
            "Reserve Seat Clicked"
          )
     break;
  
    default:
      break;
  }
 
 }

 const filterCards = isUsCountry(country) ? TileSection.filter(({ ENUM })=> ENUM != "EMI_RFI" ) : TileSection

  return (
    <div
      ref={sectionRef}
      className={clsx(styles.feeSectionProgramTemplete,"lining-nums")}
      onPointerEnter={warmModals}
      onTouchStart={warmModals}
    >
      {filterCards.map(({ ENUM, Heading, Link, Logo, Subheading })=>
      
      <div 
        className={styles.tile}
        onClick={() => invokeRFI({ENUM, Link})} 
        key={Heading}
      >
        <h3>{Heading}</h3>
        <div className={styles.sublabel}>{Subheading}</div>
        <img
          className={styles.imageLabel}
          src={Logo?.data?.attributes?.url}
          alt="Amity Online"
        />
      </div>
      
      )}
      
    </div>
  );
}
